import { useRequest } from 'ahooks';
import dayjs from 'dayjs';
import { useAtomValue } from 'jotai';
import { useRef, useState } from 'react';

import { getJackpotRankList } from '@/api/jackpot';
import BlurryLoadingImage from '@/components/progressive-img';
import { emitterAtom } from '@/jotai/emitter';
import globalStore from '@/stores/store';
import { generateHashFromText } from '@/utils/img';

import styles from './styles.module.less';

export default function JackpotSwiper() {
  const ref = useRef<any>();
  const [data, setData] = useState<any[]>([]);
  const emitter = useAtomValue(emitterAtom);

  const userid = globalStore.initialState.userid;
  const lastId = (userid && userid?.toString()?.slice(-1)) ?? 0;
  const usedImages = new Set<number>();
  const imagesMap = new Map();
  usedImages.add(lastId);
  imagesMap.set(`${userid}`, lastId);
  useRequest(getJackpotRankList, {
    onSuccess: res => {
      setData(
        res?.record
          ?.map(item => {
            let imageIndex;
            if (imagesMap.has(`${item.userid}`)) {
              imageIndex = imagesMap.get(`${item.userid}`);
            } else {
              imageIndex = generateHashFromText(`${item.userid}`) % 10;
              // 使用线性探测法，确保唯一性
              while (usedImages.has(imageIndex)) {
                imageIndex = (imageIndex + 1) % 10;
              }
              usedImages.add(imageIndex);
              imagesMap.set(`${item.userid}`, imageIndex);
            }
            console.log('imageIndex', imageIndex);
            return {
              ...item,
              imageIndex
            };
          })
          ?.slice(0, 5)
      );
    }
  });
  emitter.useSubscription(sub => {
    if (sub?.type === 'jprecord') {
      let imageIndex;
      if (imagesMap.has(`${sub?.data.userid}`)) {
        imageIndex = imagesMap.get(`${sub?.data.userid}`);
      } else {
        imageIndex = generateHashFromText(`${sub?.data.userid}`) % 10;
        // 使用线性探测法，确保唯一性
        while (usedImages.has(imageIndex)) {
          imageIndex = (imageIndex + 1) % 10;
        }
        usedImages.add(imageIndex);
        imagesMap.set(`${sub?.data.userid}`, imageIndex);
      }
      setTimeout(() => {
        const dataLength = data.length;
        setData([
          {
            ...sub?.data,
            rdate: dayjs(sub?.data?.addtime ? sub?.data.addtime * 1000 : undefined).format('MM/DD HH:mm'),
            imageIndex
          },
          ...data
        ]);
        if (ref.current) {
          const translateY = dataLength - 4;
          ref.current.style.transition = `transform 500ms ease-in-out`;
          ref.current.style.transform = `translateY(${translateY * 0.7}rem)`;
        }
      }, 7000);
    }
  });
  return (
    <div ref={ref} className={styles.rank}>
      {data?.map(item => (
        <div className={styles.rank_item} key={`${item?.award}-${item.userid}-${item.rdate}`}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <BlurryLoadingImage
              src={`${window.imgPrefix}/img/avatar/default_img_man_${item?.imageIndex}.webp`}
              loading="lazy"
              alt=""
            />
            <div className={styles.rank_award} style={{ width: '0.85rem' }}>
              {item?.username || 'user**'}
            </div>
            <div className={styles.rank_award}>$ {item?.award}</div>
          </div>
          <div className={styles.rank_time}>
            **{item?.userid?.toString()?.slice(4)} {item.rdate}
          </div>
        </div>
      ))}
    </div>
  );
}
